export default __webpack_public_path__ + "static/media/GothaMed.e57b6886.otf";